
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import type { ReactNode } from 'react'

import { LegacyDashboardStickyHeader } from '../../shared/LegacyDashboardStickyHeader'

import '../legacy-online-books.css'

export function LegacyTopHeader({
  actions,
  onBack,
  title,
}: {
  readonly actions?: ReactNode
  readonly onBack: () => void
  readonly title: string
}) {
  return (
    <LegacyDashboardStickyHeader
      className="legacyBookTopHeader"
      contentClassName="legacyBookHeaderBox"
    >
        <button
          aria-label="Back"
          className="legacyBookBackButton"
          onClick={onBack}
          type="button"
        >
          <ArrowBackRoundedIcon fontSize="large" />
        </button>
        <div className="legacyBookHeaderTitle">
          <div className="dialogeTitle">
            <div>{title}</div>
          </div>
        </div>
        {actions ? <div className="legacyBookHeaderActions">{actions}</div> : null}
    </LegacyDashboardStickyHeader>
  )
}

export function LegacyBookState({ message }: { readonly message: string }) {
  return (
    <div className="legacyBookState">
      <p>{message}</p>
    </div>
  )
}


